module.exports = __webpack_public_path__ + "media/images/riders/small/REBECCA_MCONNELL-13b09add77cba845cff2e7aec636f589.png";